import { findMessage } from '@bimser/components';
import { createGuid, IDictionary, MLHelper, toLowerCase } from '@bimser/core';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { IMenuDesignerItem } from '../../../../common/entities/IMenuDesignerItem';
import { IMenuItem } from '../../../../common/entities/IMenuItem';

export function findMenuItemWithParameter(
	items: IMenuItem[],
	parameter: string,
	value: string
): IMenuItem {
	let item = null;
	items.forEach(i => {
		if (_get(i, ['parameters', parameter]) == value) {
			item = i;
		}
		if (!item && i.children) {
			item = findMenuItemWithParameter(i.children, parameter, value);
		}
	});
	return item;
}

export function menuItemToDesigner(item: IMenuItem): IMenuDesignerItem {
	const _children: IDictionary<IMenuDesignerItem> = {};
	if (item.children.length) {
		item.children.forEach(_item => {
			_children[_item.id] = menuItemToDesigner(_item);
		});
	}
	return {
		...item,
		children: _children
	};
}

export function menuDesignerItemToMenuItem(item: IMenuDesignerItem): IMenuItem {
	let _children: IMenuItem[] = [];
	if (Object.keys(item.children).length) {
		_children = Object.values(item.children).map(w => menuDesignerItemToMenuItem(w));
	}
	return {
		...item,
		children: _children
	};
}

export function menuItemArrayToDesignerDictinary(
	items: IMenuItem[]
): IDictionary<IMenuDesignerItem> {
	const _result: IDictionary<IMenuDesignerItem> = {};
	items.forEach(_item => {
		_result[_item.id] = menuItemToDesigner(_item);
	});
	return _result;
}

export function menuItemDesignerDictinaryToArray(
	items: IDictionary<IMenuDesignerItem>
): IMenuItem[] {
	return Object.values(items).map(item => menuDesignerItemToMenuItem(item));
}

export function mapArrToMap(arr: IMenuItem[]) {
	const map: Map<string, IMenuItem[]> = new Map();
	let Regx = /^[A-Za-z_ğüşıöçĞÜŞİÖÇ]$/;
	arr.forEach(item => {
		const mlCaption = MLHelper.getMLText(item.caption).trim();
		let firstChar = mlCaption[0];
		if (!Regx.test(toLowerCase(firstChar))) {
			firstChar = '#';
		} else {
			firstChar = firstChar.toLocaleUpperCase();
		}
		if (map.get(firstChar) == null) {
			map.set(firstChar, [item]);
		} else {
			const arr = map.get(firstChar);
			arr.push(item);
			map.set(firstChar, arr);
		}
	});
	const mapAsc = new Map([...map.entries()].sort((a, b) => a[0].localeCompare(b[0])));
	const mapToList = (map: Map<string, IMenuItem[]>) => {
		const result: IMenuItem[] = [];
		map.forEach((value: IMenuItem[], key: string) => {
			result.push({
				text: key,
				data: 'isDisableTitle'
			});
			result.push(...value);
		});
		return result;
	};
	return mapToList(mapAsc);
}

export function filterDesignerItems(
	items: IMenuItem[],
	depthIndex: number = 0,
	parentItem?: IMenuItem
) {
	let _items = [...items];
	_items = _items.map((item: any) => {
		item = updateDesignerItemsParams(item, depthIndex, parentItem);
		if (item.children && item.children.length) {
			item.children == filterDesignerItems(item.children, depthIndex + 1, item);
		}
		return item;
	});
	return _items;
}

export function updateDesignerItemsParams(
	item: IMenuItem,
	depthIndex: number,
	parentItem: IMenuItem
) {
	const guid = item.id || createGuid();
	item.isBaseItem = false;
	item.id = guid;
	if (depthIndex == 0) {
		item.level = 0;
		item.path = [guid];
	} else {
		item.level = parentItem.level + 1;
		item.path = [...parentItem.path, guid];
	}
	return item;
}

export function sortItemChildren(items: IMenuItem[], includeOrderIndex: boolean = true) {
	const getOrderIndex = (item: IMenuItem) =>
		item.parameters?.orderIndex
			? parseInt(item.parameters.orderIndex)
			: item.displayOrderNo !== 0
			? item.displayOrderNo
			: undefined;
	const getAlphabetic = (item: IMenuItem) => {
		let key = findMessage.get('100017');

		if (!_isEmpty(item.caption)) {
			key = MLHelper.getMLText(item.caption);
		} else if (item.text) {
			key = item.text;
		}

		return key.trim().toLocaleUpperCase();
	};
	const sortedItems = [...items].sort((first, second) => {
		if (includeOrderIndex) {
			if (
				first.parameters?.orderIndex !== undefined &&
				second.parameters?.orderIndex !== undefined
			) {
				const firstIndex = getOrderIndex(first);
				const secondIndex = getOrderIndex(second);
				return firstIndex - secondIndex;
			}
			if (first.parameters?.orderIndex !== undefined) return -1;
			if (second.parameters?.orderIndex !== undefined) return 1;
		}

		const firstName = getAlphabetic(first);
		const secondName = getAlphabetic(second);
		return firstName.localeCompare(secondName);
	});

	return sortedItems.map(item => ({
		...item,
		children: item.children ? sortItemChildren(item.children) : undefined
	}));
}

export const leftMenuItemColors = [
	'#740B1C',
	'#A5262D',
	'#D13538',
	'#DA3B01',
	'#8D562D',
	'#CA5011',
	'#FEAB45',
	'#FCE002',
	'#986F0B',
	'#C09C00',
	'#8CBE19',
	'#0B690C',
	'#498206',
	'#00AD58',
	'#015B71',
	'#048287',
	'#00B7C2',
	'#014D8C',
	'#0078D3',
	'#4F6AEC',
	'#5C2E90',
	'#8664B9',
	'#8478DE',
	'#871798',
	'#FCF9F6',
	'#9C0163',
	'#E2018C',
	'#393939',
	'#7A7675',
	'#697880',
	'#A0AEB2'
];
